import { BaseDataBind } from "./base";

export abstract class BaseSelectBoxDataBind extends BaseDataBind
{   
    /**
     * Iterates over select element options.
     * @param element The element to iterate.
     * @param callback Callback function called for each option.
     */
    protected iterateOptions(element: HTMLSelectElement, callback: (option: HTMLOptionElement, index: number) => void)
    {
        for(let i = 0; i < element.options.length; i++)
        {
            callback(element.options[i] as HTMLOptionElement, i);
        }
    }

    /**
     * Converts various input types to a string array.
     * @param value The value to parse.
     */
    protected parseOptions(value: any): SelectOptionData[]
    {
        let result: SelectOptionData[] = [];

        if (typeof value === 'number')
        {
            let val = value.toString();
            result = [{content: val, value: val}];
        }
        else if (typeof value === 'string')
        {
            result = value.split(',').map(o => <SelectOptionData>{value: o, content: o});
        }
        // typeof [] === 'object', check array first!
        else if (Array.isArray(value))
        {
            result = value;
        }
        else if (typeof value === 'object')
        {
            result = [value];
        }

        return result;
    }
}

export interface SelectOptionData
{
    content: string;
    value: string | number;
    disabled?: boolean;
}